
<template>
  <div >
    <div class="info-list">
     <div class="info-item" v-for="(item,index) in dataList" :key="index">
       <div class="content ">
         <div class="title" style="margin-bottom: 10px;">
          <img :src="item.img" alt="">
          {{item.title}}
        </div>
         <div>
          <div id="description" style="width: 100%;">
           {{ item.content }}
            </div>
         </div>
       </div>
     </div>

     <!-- 更多 .info-item -->
</div>
  <div style="border-top: 1px solid #eaecef;margin:0 20px;">
    <div style="float: right;margin-top: 36.5px;" class="flx-center">
      <img style="width: 20px;height: 20px;margin-right:17px" :src="$ossUrl+'icons/platform/tips.png'" alt="">
      <div>
        <div class="annotationTitle">非必需，符合可下大客户链接</div>
        <div class="annotationContent">如可提供以上材料，登记表单时请上传资料且【年销售额】选择6000万以上</div>
      </div>
    </div>
  </div>
</div>
</template>
<script>


/**
 * Index-1 component
 */
export default {
  name:"otherInfo",
  components: {
  },
  data(){
    return {
        dataList:[
          {
            title:"自有或合作工厂提供工厂质量认证或产品认证",
            content:"如ISO, BSCl, CE, FDA等",
            img:this.$ossUrl+'icons/platform/platformIcon1.png'
          },
          {
            title:"日标销售国的注册商标",
            content:"R标/M回执",
            img:this.$ossUrl+'icons/platform/platformIcon2.png'
          },
          {
            title:"非工厂型(有合作工厂)提供与合作工厂间的采购合同或发票",
            content:"",
            img:this.$ossUrl+'icons/platform/platformIcon3.png'
          },
         
        ]
    }
  },
  methods: {
   
  }
};
</script>
<style src="./componentsIndex.css" scoped></style>